import { useCallback } from 'react';
import { useDockviewApi } from './dockview-context.js';
import { useAppStore, useActiveTabId } from './store.js';
import type { PanelComponentKey, PanelParams } from './components.js';

// Opens the Bolt-On Screening panel seeded from a company — the Company
// Overview "Find bolt-ons nearby" button. The panel is spawned with
// initialState.seedEntityId; it fetches that company's footprint centroid +
// subsegment itself (GET /bolt-on/footprint/:id) and drops the seed there, so
// the catchment is pre-filled to the company's location. Opened floating (it's
// a map) — the user can dock it.

export function useOpenBoltOn(): (entityId: string) => void {
  const activeTabId = useActiveTabId();
  const apiRef = useDockviewApi();
  const addPanelToStore = useAppStore((s) => s.actions.addPanel);

  return useCallback(
    (entityId: string) => {
      if (!activeTabId) return;
      const api = apiRef.current;
      if (!api) return;

      const newPanelId = addPanelToStore(activeTabId, {
        component: 'bolt-on',
        title: 'Catchment',
      });
      const cascade = api.panels.filter((p) => p.api.location.type === 'floating').length;
      const offset = 24 * cascade;
      api.addPanel<PanelParams>({
        id: newPanelId,
        component: 'bolt-on' as PanelComponentKey,
        title: 'Catchment',
        params: {
          tabId: activeTabId,
          panelId: newPanelId,
          initialState: { seedEntityId: entityId },
        },
        floating: {
          position: { left: 100 + offset, top: 70 + offset },
          width: 760,
          height: 520,
        },
      });
    },
    [activeTabId, apiRef, addPanelToStore],
  );
}
